<template>
    <section class="inline large">
        <div class="grid xs-grid-cols-1 fixed fixed-max-sm gap-5 sm-grid-cols-2 middle">
            <img alt="Home Value" loading="lazy" :src="contentSectionImg1" class="panel-img order-1" />
            <div class="order-2 grid xs-grid-cols-1 gap-1">
                <h2 class="f2 text-bold">{{ molang('homeOwner.HomeMarketValue') }}</h2>
                <div class="info">
                    {{ molang('homeOwner.Valuation') }}
                </div>
            </div>
            <img alt="Track Equity" loading="lazy" :src="contentSectionImg2" class="panel-img order-3 order-sm-5" />
            <div class="order-4 grid xs-grid-cols-1 gap-1">
                <h2 class="f2 text-bold">{{ molang('homeOwner.MortgageBalance') }}</h2>
                <div class="info">
                    {{ molang('homeOwner.TrackHome') }}
                </div>
            </div>
            <img alt="Maintenance Alerts" loading="lazy" :src="contentSectionImg3" class="panel-img order-5" />
            <div class="order-6 grid xs-grid-cols-1 gap-1">
                <h2 class="f2 text-bold">{{ molang('homeOwner.PersonalizedAlerts') }}</h2>
                <div class="info">
                    {{ molang('homeOwner.PersonalizedMaintanance') }}
                </div>
            </div>
            <img alt="Savings Alerts" loading="lazy" :src="contentSectionImg4" class="panel-img order-7 order-sm-9" />
            <div class="order-8 grid xs-grid-cols-1 gap-1">
                <h2 class="f2 text-bold">{{ molang('homeOwner.ExpertGuidance') }}</h2>
                <div class="info">
                    {{ molang('homeOwner.PersonalizedSuggestions') }}
                </div>
            </div>
        </div>
    </section>
    <section>
        <div class="fixed fixed-max-sm bg-default inline large welcome corner">
            <div class="flex vertical large middle center">
                <h2 class="f2 text-center text-bold">{{ molang('homeOwner.LifeInvestment') }}</h2>
                <div class="text-center f5">{{ molang('homeOwner.YourHome') }}</div>
                <mvtInputGeo class="large default" ref="addressInput" v-model="geoInfo" :placeholder="molang('homeOwner.Address')" :options="{types:['address']}">{{
                    molang('homeOwner.GetStarted')
                }}</mvtInputGeo>
            </div>
        </div>
    </section>
</template>

<script src="./owner-content.js"></script>
